export enum EduType {
  /** 实习生-中国 */
  InternChinese = 'internChinese',
  /** 实习生-非中国 */
  InternForeign = 'internForeign',
  /** 非实习生-中国-专科 */
  ChineseCollege = 'chineseCollege',
  /** 非实习生-中国-非专科 */
  ChineseNonCollege = 'chineseNonCollege',
  /** 非实习生-非中国-专科 */
  ForeignCollege = 'foreignCollege',
  /** 非实习生-非中国-非专科 */
  ForeignNonCollege = 'foreignNonCollege',

  /** default: 普通场景 */
  Default = 'default',
  /** notTopDegree: 非最高学历 */
  NotTopDegree = 'notTopDegree',
}

// 证书类型
export enum CertificateType {
  /** 毕业证书（非实习生） */
  Diploma = 'diploma',

  /** 学位证书（非实习生） */
  Degree = 'degree',

  // 专科有，高中没有，所以是选填，这里高中和专科一起判断，没问题
  /** 职业资格证书（非实习生） */
  Professional = 'professional',

  /** 留服认证书（非实习生） */
  ForeignAuth = 'foreignAuth',

  /** 教育部学籍在线验证报告（中国实习生） */
  OnlineVerification = 'onlineVerification',

  /** 在读证明（非中国实习生） */
  StudyProof = 'studyProof',
}

// 证书类型
export const CertificateCodeItemKeyType = {
  /** 毕业证书编码 formItemKey */
  [CertificateType.Diploma]: 'educationCode',
  /** 学位证书编码 formItemKey */
  [CertificateType.Degree]: 'degreeCode',
};

// 证书类型label
export const CertificateCodeItemLabelType = {
  /** 毕业证书编码 formItemKey */
  [CertificateType.Diploma]: '毕业证书编码',
  /** 学位证书编码 formItemKey */
  [CertificateType.Degree]: '学位证书编码',
};

export interface SupplementaryFile {
  attachmentId: string;
  attachmentName: string;
  attachmentUrl: string;
  attachmentFileType: number;
}
